import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { ModalDisableCheckoutStyled } from '../../ModalDisableCheckoutStyled';

export const ModalDisableCheckoutStyledOVGB = styled(ModalDisableCheckoutStyled)`

`;
